import salesagentDotAiLogo from "../assets/salesagentDotAiLogo.png";
import MoreVertIcon from "../assets/MoreVertIcon.js";
import Menu from "./Menu";
import React, { useRef, useState } from "react";
import {
  sendFlowMsgsToSlack,
  sendFlowMsgsAndConciseMsgsToSlack,
} from "../services/flowService";

const SmallHeader = ({ selectedFlowId }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState(null);
  const moreIconRef = useRef(null);

  const handleMenuOptionClick = (option) => {
    setMenuOpen(false);
    setMenuPosition(null);
    if (!selectedFlowId) {
      alert("Please select a flow first");
      return;
    }
    if (option === "Send msgs to slack") {
      sendFlowMsgsToSlack(selectedFlowId);
    } else if (option === "Send msgs and concise msgs to slack") {
      sendFlowMsgsAndConciseMsgsToSlack(selectedFlowId);
    }
  };

  const handleMoreIconClick = () => {
    if (!menuOpen) {
      const rect = moreIconRef.current.getBoundingClientRect();
      const newPosition = {
        top: rect.bottom,
        left: rect.left - 224, // 56 * 4 = 224 (w-56 in Tailwind is 14rem = 224px)
      };
      setMenuPosition(newPosition);
      setMenuOpen(true);
    } else {
      setMenuOpen(false);
      setMenuPosition(null);
    }
  };

  return (
    <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
      <div className="px-3 py-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start">
            <button
              data-drawer-target="logo-sidebar"
              data-drawer-toggle="logo-sidebar"
              aria-controls="logo-sidebar"
              type="button"
              className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
              <span className="sr-only">Open sidebar</span>
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  clipRule="evenodd"
                  fillRule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
              </svg>
            </button>
            <a href="/" className="flex ml-2 md:mr-4">
              <img
                className={`w-[13rem] py-1`}
                src={salesagentDotAiLogo}
                alt=""
              />
            </a>
          </div>
          <div className="relative">
            <button
              ref={moreIconRef}
              onClick={handleMoreIconClick}
              className="p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
              aria-label="More options">
              <MoreVertIcon />
            </button>
            {menuOpen && menuPosition && (
              <Menu
                anchorRef={moreIconRef}
                open={menuOpen}
                onClose={() => {
                  setMenuOpen(false);
                  setMenuPosition(null);
                }}
                options={[
                  "Send msgs to slack",
                  "Send msgs and concise msgs to slack",
                ]}
                onOptionClick={handleMenuOptionClick}
                position={menuPosition}
              />
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default SmallHeader;
